<template>
  <section id="Kontakt" class="pb-5 bg-light">
    <div class="container py-5">
      <div class="row">
        <div class="col-12 text-center">
          <h2 class="my-5" data-aos="fade-up" data-aos-delay="500">Kontakt</h2>
          <p class="text-dark" data-aos="fade-up" data-aos-delay="200">Ich freue mich sehr auf Ihre Anfrage.<br>Um Ihnen ein persönliches Angebot machen zu können, benötige ich folgende Infos:</p>
          <p class="text-dark" data-aos="fade-up" data-aos-delay="200">- Art der Veranstaltung<br>(Hochzeitspakete beginnen um 17 Uhr und nicht später)<br>- Datum der Veranstaltung<br>- Veranstaltungsort<br>- Anzahl der Gäste</p>
          <img src="@/assets/img/medi-kopfhoehrer.jpeg" class=" col-8 col-md-6 col-lg-4 mt-5 medi" data-aos="fade-up" data-aos-delay="500" alt="...">
        </div>
      </div>
      <div class="row mt-5 g-5">

      <!-- Mail START -->
        <div class="col-12 col-xl-6 col-xxl-3" data-aos="fade-up" data-aos-delay="500">
          <div class="border-1 border border-dark px-3 pb-3 rounded-2 h-100 bg-dark">
            <div class="bg-info text-white p-3 rounded-circle feature">
              <i class="'bi bi-envelope fs-4'"></i>
            </div>
            <p class="mt-3 text-center"><a href="mailto:djmedievent@web.de" class="contact-link">djmedievent@web.de</a></p>
          </div>
        </div>
      <!--Mail END -->

        <!-- Phone START -->
        <div class="col-12 col-xl-6 col-xxl-3" data-aos="fade-up" data-aos-delay="500">
          <div class="border-1 border border-dark px-3 pb-3 rounded-2 h-100 bg-dark">
            <div class="text-white p-3 rounded-circle feature" style="background: #25D366">
              <i class="'bi bi-telephone fs-4'"></i>
            </div>
            <p class="mt-3 text-center"><a href="tel:015170124627" target="_blank" class="contact-link">0151 - 701 246 27</a></p>
          </div>
        </div>
        <!-- Phone END -->

      <!-- Facebook START -->
        <div class="col-12 col-xl-6 col-xxl-3" data-aos="fade-up" data-aos-delay="500">
          <div class="border-1 border border-dark px-3 pb-3 rounded-2 h-100 bg-dark">
            <div class="text-white p-3 rounded-circle feature" style="background-color:#3b5998">
              <i class="'bi bi-facebook fs-4'"></i>
            </div>
            <p class="mt-3 text-center"><a href="http://facebook.com/djmedi" target="_blank" class="contact-link">facebook.com/djmedi</a></p>
          </div>
        </div>
      <!-- Facebook END -->

        <!-- Instagram START -->
        <div class="col-12 col-xl-6 col-xxl-3" data-aos="fade-up" data-aos-delay="500">
          <div class="border-1 border border-dark px-3 pb-3 rounded-2 h-100 bg-dark">
            <div class="text-white p-3 rounded-circle feature" style="background: linear-gradient(to right, #833ab4,#fd1d1d,#fcb045);">
              <i class="'bi bi-instagram fs-4'"></i>
            </div>
            <p class="mt-3 text-center"><a href="http://instagram.com/dj_medi" target="_blank" class="contact-link">instagram.com/dj_medi</a></p>
          </div>
        </div>
        <!-- Instagram END -->

      </div>
    </div>
  </section>
</template>

<script setup>

</script>

<style scoped>
.feature {
  margin-top: -1rem;
}
.contact-link {
  text-decoration: none;
  color: white;
}
.contact-link:hover {
  text-decoration: underline;
}
.medi {
  margin-left: 0 !important;
  margin-right: 0 !important;
}
</style>